module.exports = __webpack_public_path__ + "img/morningRef1_thumb.3330e84b.jpg";